import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { ReportsPendingOrdersPage } from 'src/app/modals/reports-pending-orders/reports-pending-orders.page';

const routes: Routes = [
  {
    path: '',
    component: ReportsPendingOrdersPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ReportsPendingOrdersPage]
})
export class ReportsPendingOrdersPageModule {}
